/**
 * SevBadge — severity badge for alert events (info / warn / critical).
 * NL labels per design/ui/components.jsx SEV_META.
 */
import { cn } from './cn';

export type Severity = 'info' | 'warning' | 'critical';

export interface SevBadgeProps {
  sev: Severity;
  /** Override label (default is NL-localised). */
  label?: string;
  className?: string;
}

const SEV_CLASS: Record<Severity, string> = {
  critical: 'bg-fail-50 text-fail-700',
  warning: 'bg-warn-50 text-warn-700',
  info: 'bg-info-50 text-info-700',
};

const SEV_DOT: Record<Severity, string> = {
  critical: 'bg-fail-600',
  warning: 'bg-warn-600',
  info: 'bg-info-600',
};

const SEV_LABEL: Record<Severity, string> = {
  critical: 'Kritiek',
  warning: 'Waarschuwing',
  info: 'Info',
};

export function SevBadge({ sev, label, className }: SevBadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold uppercase tracking-wide',
        SEV_CLASS[sev],
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', SEV_DOT[sev])} />
      {label ?? SEV_LABEL[sev]}
    </span>
  );
}
